var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-info"},[_c('div',{staticClass:"flex-grow-1"},[_vm._t("default")],2),_c('div',{staticClass:"flex-grow-0 sidebar-info__buttons"},[_vm._t("buttons")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }